import React, { useState, useRef, useCallback, useEffect } from 'react';
import styles from './completeModal.module.scss';
import Modal from '@src/components/modal/Modal';
import Button from '@src/components/button/Button';
import Spinner from '@src/components/spinner/Spinner';
import artworkImage from './artwork.png';

type Props = {
  open: boolean;
  loading: boolean;
  onClose: () => void;
  onComplete: () => void;
};

function AutoCompleteModal(props: Props) {
  const { open, loading, onClose, onComplete } = props;
  const [percent, setPercent] = useState<number>(0);
  let countDownTimer = useRef<NodeJS.Timeout | null>(null);

  const startCountDown = useCallback(() => {
    countDownTimer.current = setInterval(() => {
      setPercent(p => {
        if (p >= 99) {
          onComplete();
          if (countDownTimer.current) {
            clearInterval(countDownTimer.current);
          }
          return p;
        }
        return p + 1
      });
    }, 5000 / 100)
  }, [onComplete]);

  useEffect(() => {
    startCountDown();
    return () => {
      if (countDownTimer.current) {
        clearInterval(countDownTimer.current)
        countDownTimer.current = null;
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleCancel = useCallback(() => {
    if (countDownTimer.current) {
      clearInterval(countDownTimer.current)
      countDownTimer.current = null;
    }
    onClose();
  }, [onClose])

  const handleComplete = useCallback(() => {
    if (countDownTimer.current) {
      clearInterval(countDownTimer.current)
      countDownTimer.current = null;
    }
    onComplete();
  }, [onComplete])

  return (
    <Modal global={false} open={open} onClose={handleCancel} className={styles.autoWrapper} closeButton={false}>
      <div className={styles.opContent}>
        <div className={styles.artworkView}>
          <img src={artworkImage} alt='art' />
        </div>
        <div className={styles.opCongrateView}><h2>Congratulations!</h2><span>{'You have successfully completed this Lesson.'}</span></div>
        <div className={styles.notifyDetailView}>
          <div className={styles.notifyDetailTitle}>
          This lesson will close in... <span>{Math.ceil(5 - 5.0 / 100 * (percent || 0))}</span> second
          </div>
        </div>
        <div className={styles.buttonContainer}>
          <Button size={'small'} disabled={loading} outline={true}  onClick={handleCancel} className={styles.cancelButton} label={'Cancel'} />
          <div onClick={loading ? () =>{} : handleComplete} className={styles.completeButton} style={{cursor: loading ? 'not-allowed' : 'pointer'}}>
            <div className={styles.progressBar} style={{width: percent < 99 ? `${percent}%` : '', right: percent >= 99 ? '-1px' : '' }}></div>
            <div className={styles.buttonText}>{loading ? <div style={{width: 40, marginRight: 10}}><Spinner width={40}/></div> : undefined}<span>Mark Lesson Completed</span></div>
          </div>
        </div>
      </div>
    </Modal>
  );
}

export default AutoCompleteModal;
